import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Heart.svg",
  "use": "Heart.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Heart.svg\"><path d=\"M20.5558,13.0207A12.5475,12.5475,0,0,1,32.01,20.3694a12.5686,12.5686,0,0,1,24.0007,5.036c0,15.915-19.9741,29.6157-24.0007,29.6157s-24-13.7007-24-29.6157A12.4659,12.4659,0,0,1,20.5558,13.0207Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol